import React from 'react';
import { ICON_COMPONENT_MAP } from './lucideIconMap';
import { Square } from 'lucide-react';
import { DynamicIcon } from 'lucide-react/dynamic';

/**
 * Renders a Lucide icon by kebab-case name string.
 *
 * The static map covers the common names and renders at once. Any other Lucide
 * name loads by name, as Nucleus's SchemaIcon does (nucleus/faces.js): schemas
 * name icons from all of Lucide, and a name outside the map used to show as an
 * empty square. A name Lucide does not have falls back to that square.
 */
export default function SchemaIcon({ iconName, size = 14, style, className, ...rest }) {
  const placeholder = <Square size={size} strokeWidth={1.5} style={{ ...style, opacity: 0.15 }} className={className} {...rest} />;
  const IconComponent = ICON_COMPONENT_MAP[iconName];
  if (IconComponent) {
    return <IconComponent size={size} strokeWidth={2} style={style} className={className} {...rest} />;
  }
  if (!iconName) return placeholder;
  return <DynamicIcon name={iconName} size={size} strokeWidth={2} style={style} className={className} fallback={() => placeholder} {...rest} />;
}
